import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onExpired = () => setUser(false);
    window.addEventListener("bsm:session-expired", onExpired);
    return () => window.removeEventListener("bsm:session-expired", onExpired);
  }, []);

  const login = async (email, password, remember = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    if (data.requires_code) return data;
    setUser(data.user);
    return data.user;
  };

  const verifyCode = async (challenge_id, code, trust_device) => {
    const { data } = await api.post("/auth/verify-code", { challenge_id, code, trust_device });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  const logoutAll = async () => {
    try { await api.post("/auth/logout-all"); } catch (e) {}
    setUser(false);
  };

  const updateUser = (patch) => setUser((u) => (u ? { ...u, ...patch } : u));

  return (
    <AuthContext.Provider value={{ user, setUser, login, verifyCode, logout, logoutAll, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
